import React from 'react'
import { createContext, useState } from "react";
import AuthContext from "./AuthContext.js";
import ClientContext from "./ClientContext.js";
import StatusContext from './StatusContext.js';
import axios from "axios"
import { languagesamples } from "../data/LanguageSamples.ts"
import { assistantsamples } from "../data/AssistantSamples.ts"
import { assistantsamples_Serbian } from "../data/AssistantSamples_Serbian.ts"
import { assistantsamples_Spanish } from "../data/AssistantSamples_Spanish.ts"
import { assistantsamples_Portuguese } from "../data/AssistantSamples_Portuguese.ts"
import { assistantsamples_French } from "../data/AssistantSamples_French.ts"
import { assistantsamples_German } from "../data/AssistantSamples_German.ts"
import { businesssamples } from "../data/BusinessSamples.ts"
import { businesssamples_Serbian } from "../data/BusinessSamples_Serbian.ts"
import { businesssamples_Spanish } from "../data/BusinessSamples_Spanish.ts"
import { businesssamples_Portuguese } from "../data/BusinessSamples_Portuguese.ts"
import { businesssamples_French } from "../data/BusinessSamples_French.ts"
import { businesssamples_German } from "../data/BusinessSamples_German.ts"
import { interviewsamples } from "../data/InterviewSamples.ts"
import { config } from '../config.js';
import { sortChats } from './StatusContext.js';

const AssistantContext = createContext();

export default AssistantContext;

var topic = '';
var topicSummary = ''
var topicSummaryIndex = 0

  
export const AssistantProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const[chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [confirmDelete, setConfirmDelete] = useState([])
    const [status, setStatus] = useState();
    const [displayrelated, setDisplayRelated] = useState(true)
    const [request, setRequest] = useState('')
    
   
    const {
        currentUser, 
        checkCurrentUser,
        checkServerCode, 
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
        ScrollResponse,
        setIsLoading,
        isLoading,
        mainLanguage,
        changeLanguage,
        getChats,
        setShowLoginDialog,
        handleFocus,
        setWaitOnResponse,
        getAIProvider, 
         getAIModel,
         getAIName,
        
        
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);

   
    const getTextSummary = async (text) => {

        let summary = ''
        let request = changeLanguage('assistant', 'summarizetext');
       
        let rqst = ''

        if (text.charAt[0] !== '"')
            rqst = '"' + text
        if (text.charAt[text.length-1] !== '"')
            rqst = rqst + '"'

        request = request + rqst;

        let req = {
            user: currentUser,
            request: request,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
        
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                    withCredentials:true
                })

            let server_response = JSON.parse(res.data);

            summary = server_response.data

            updateCredits(server_response.tokens)
    
        } catch(err)
        {
            setStatus(`Error: ${checkServerCode(err.response.data)}`)

        }

        return summary
    }

    const displaySample = (sample) => {

        console.log("displaySample:", sample)
        if (sample === "French")
        {
            displayChat(languagesamples[0])
            setStatus(changeLanguage('status', 'enteratextandsubmit'))
        }
        if (sample === "Spanish")
        {
            displayChat(languagesamples[1])
            setStatus(changeLanguage('status', 'enteratextandsubmit'))
        }
        if (sample === "Italian")
        {
            displayChat(languagesamples[2])
            setStatus(changeLanguage('status', 'enteratextandsubmit'))
        }
        if (sample === "Portuguese")
        {
            displayChat(languagesamples[3])
            setStatus(changeLanguage('status', 'enteratextandsubmit'))
        }
        if (sample === "Chinese")
        {
            displayChat(languagesamples[4])
            setStatus(changeLanguage('status', 'enteratextandsubmit'))
        }
        if (sample === "English")
        {
            displayChat(languagesamples[5])
            setStatus(changeLanguage('status', 'enteratextandsubmit'))
        }

        if (sample === "Alexander the Great")
        {
            if (mainLanguage === 'Serbian')
                displayChat(assistantsamples_Serbian[0])
            else if (mainLanguage === 'Spanish')
                displayChat(assistantsamples_Spanish[0])
            else if (mainLanguage === 'Portuguese')
                displayChat(assistantsamples_Portuguese[0])
            else if (mainLanguage === 'French')
                displayChat(assistantsamples_French[0])
            else if (mainLanguage === 'German')
                displayChat(assistantsamples_German[0])
            else
                displayChat(assistantsamples[0])

            setStatus(changeLanguage('status', 'exampletext1'))
        }

        if (sample === "Assistant Email")
        {
            if (mainLanguage === 'Serbian')
                displayChat(assistantsamples_Serbian[1])
            else if (mainLanguage === 'Spanish')
                displayChat(assistantsamples_Spanish[1])
            else if (mainLanguage === 'Portuguese')
                displayChat(assistantsamples_Portuguese[1])
            else if (mainLanguage === 'French')
                displayChat(assistantsamples_French[1])
            else if (mainLanguage === 'German')
                displayChat(assistantsamples_German[1])
            else
                displayChat(assistantsamples[1])
            setStatus(changeLanguage('status', 'exampletext2'))
        }
        if (sample === "Article")
        {
            if (mainLanguage === 'Serbian')
                displayChat(assistantsamples_Serbian[2])
            else if (mainLanguage === 'Spanish')
                displayChat(assistantsamples_Spanish[2])
            else if (mainLanguage === 'Portuguese')
                displayChat(assistantsamples_Portuguese[2])
            else if (mainLanguage === 'French')
                displayChat(assistantsamples_French[2])
            else if (mainLanguage === 'German')
                displayChat(assistantsamples_German[2])
            else
                displayChat(assistantsamples[2])
            setStatus(changeLanguage('status', 'exampletext3'))
        }
        if (sample === "Advice")
        {
            if (mainLanguage === 'Serbian')
                displayChat(assistantsamples_Serbian[3])
            else if (mainLanguage === 'Spanish')
                displayChat(assistantsamples_Spanish[3])
            else if (mainLanguage === 'Portuguese')
                displayChat(assistantsamples_Portuguese[3])
            else if (mainLanguage === 'French')
                displayChat(assistantsamples_French[3])
            else if (mainLanguage === 'German')
                displayChat(assistantsamples_German[3])
            else
                displayChat(assistantsamples[3])
            setStatus(changeLanguage('status', 'exampletext4'))
        }
        if (sample === "Vacation")
        {
            if (mainLanguage === 'Serbian')
                displayChat(assistantsamples_Serbian[4])
            else  if (mainLanguage === 'Spanish')
                displayChat(assistantsamples_Spanish[4])
            else if (mainLanguage === 'Portuguese')
                displayChat(assistantsamples_Portuguese[4])
            else if (mainLanguage === 'French')
                displayChat(assistantsamples_French[4])
            else if (mainLanguage === 'German')
                displayChat(assistantsamples_German[4])
            else
                displayChat(assistantsamples[4])
            setStatus(changeLanguage('status', 'exampletext5'))
        }
        if (sample === "Assistant Story")
        {
            if (mainLanguage === 'Serbian')
                displayChat(assistantsamples_Serbian[5])
            else  if (mainLanguage === 'Spanish')
                displayChat(assistantsamples_Spanish[5])
            else if (mainLanguage === 'Portuguese')
                displayChat(assistantsamples_Portuguese[5])
            else if (mainLanguage === 'French')
                displayChat(assistantsamples_French[5])
            else if (mainLanguage === 'German')
                displayChat(assistantsamples_German[5])
            else
                displayChat(assistantsamples[5])
            setStatus(changeLanguage('status', 'exampletext6'))
        }
        if (sample === "Meeting")
        {
            if (mainLanguage === 'Serbian')
                displayChat(businesssamples_Serbian[0])
            else if (mainLanguage === 'Spanish')
                displayChat(businesssamples_Spanish[0])
             else if (mainLanguage === 'Portuguese')
                displayChat(businesssamples_Portuguese[0])
            else if (mainLanguage === 'French')
                displayChat(businesssamples_French[0])
            else if (mainLanguage === 'German')
                displayChat(businesssamples_German[0])
            else
                displayChat(businesssamples[0])
            
        }
        if (sample === "Presentation")
        {
            if (mainLanguage === 'Serbian')
                displayChat(businesssamples_Serbian[1])
            else if (mainLanguage === 'Spanish')
                displayChat(businesssamples_Spanish[1])
            else if (mainLanguage === 'Portuguese')
                displayChat(businesssamples_Portuguese[1])
            else if (mainLanguage === 'French')
                displayChat(businesssamples_French[1])
            else if (mainLanguage === 'German')
                displayChat(businesssamples_German[1])
            else
                displayChat(businesssamples[1])
            
        }
        if (sample === "Product Manager")
        {
            displayChat(interviewsamples[0])
            setStatus(changeLanguage('status', 'exampletext8'))
        }
        if (sample === "Business Email")
        {
            if (mainLanguage === 'Serbian')
                displayChat(businesssamples_Serbian[2])
            else if (mainLanguage === 'Spanish')
                displayChat(businesssamples_Spanish[2])
            else if (mainLanguage === 'Portuguese')
                displayChat(businesssamples_Portuguese[2])
            else if (mainLanguage === 'French')
                displayChat(businesssamples_French[2])
            else if (mainLanguage === 'German')
                displayChat(businesssamples_German[2])
            else
                displayChat(businesssamples[2])
            setStatus(changeLanguage('status', 'exampletext9'))
        }
        if (sample === "Interview")
        {
            if (mainLanguage === 'Serbian')
                displayChat(businesssamples_Serbian[3])
            else  if (mainLanguage === 'Spanish')
                displayChat(businesssamples_Spanish[3])
            else if (mainLanguage === 'Portuguese')
                displayChat(businesssamples_Portuguese[3])
            else if (mainLanguage === 'French')
                displayChat(businesssamples_French[3])
            else if (mainLanguage === 'German')
                displayChat(businesssamples_German[3])
            else
                displayChat(businesssamples[3])
            setStatus(changeLanguage('status', 'exampletext10'))
        }

        if (sample === "...")
        {
            setStatus("")
        }
        

    }

    const isPromptandResponses = () => {
        return promptsandresponses.length;
    }

    const onClearChat = () => {
        setPromptsAndResponses([])
        setConfirmDelete([])
        setChatName('')
        setStatus('')
        setChatPrompt('')
        
        topic=''
        topicSummary=''
        topicSummaryIndex = 0
    }   

    const deleteChat = async (deletionChat) => {

        console.log("Delete story:", deletionChat)

        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let newchatNames = [];

        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/stories/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)
        let adjustedChats = sortChats(filteredChats)
        console.log("Adjusted Chats:", adjustedChats)
              
        var templates = JSON.stringify( adjustedChats)
       
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/stories/save", {currentUser, templates},{
                withCredentials:true
            })
        }
        catch (err) {
            setIsLoading(false)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return;
        }

        setChatNames(adjustedChats);
        
       
        setIsLoading(false)    
    }

    const displayChat = (displayedChat) => {

        console.log("Story:", displayedChat)
        onClearChat();

        setTimeout(() => {

        //fix prompts ids to match array indexes
        let index = 0;
        displayedChat.promptsandresponses.forEach((item) => {
                item.id = index;
                index++   
        })   
       

        setPromptsAndResponses(displayedChat.promptsandresponses)
        setChatName(displayedChat.chatname)
        //backward compatibility
        displayedChat.summary ? topicSummary = displayedChat.summary : topicSummary=''
        console.log("topicSummary:", topicSummary)
        displayedChat.summaryindex ? topicSummaryIndex = displayedChat.summaryindex : topicSummaryIndex = 0
        console.log("topicSummaryIndex:", topicSummaryIndex)

        var deletes = []
        displayedChat.promptsandresponses.forEach((item) => {
             let a = {
                id: item.id,
                state: false
             }
             deletes.push(a)   
        })

        setConfirmDelete(deletes)
    },0)
    }

    const onDeletePrompt = (deletionChat) => {
        if (isLoading)
            return;
        let index = promptsandresponses.indexOf(deletionChat)
        let filteredChats = promptsandresponses.filter(chat => chat.id !== deletionChat.id)

        if (index > 0 && topicSummaryIndex)
            topicSummaryIndex -= 1

        setPromptsAndResponses(filteredChats)
        
        let deleteconfirm = [...confirmDelete]
        deleteconfirm.splice(index, 1)
        setConfirmDelete(deleteconfirm)

    }

    const changeConfirmDelete = (prompt, flag) => {
        let a = [...confirmDelete]
        a.forEach((item)=>{
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDelete(a)

    }

    const onSave = async () => {
        console.log("OnSave stories:")

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }

        let exists = false;
    
        let newChats = [];
        let newChat=[];
        let newchatNames = [];


        setIsLoading(true);

        let chatstatus = await getChats('stories');
       
        if (chatstatus.status !== 200)
        {
            setStatusNavbar("Unable to retrieve topics data.")
            setIsLoading(false);
            return;
        }

        newchatNames = chatstatus.chats;

        if ( chatstatus.status === 200)
        {
            newchatNames.forEach((chat) => {
                if (chat.chatname === chatName) {
                    let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }

                    chat.promptsandresponses = promptsandresponses;
                    newChat = chat;
                    exists = true;
                }
                newChats.push(JSON.parse(JSON.stringify(chat)));
            })
        }

        if (!exists) {
            let i = 0;

            newchatNames === 0 ? i = 1 : i = newchatNames.length;

            newChat = {
                id: i,
                chatname: chatName,
                //topic: topic,
                summary: topicSummary,
                summaryindex: topicSummaryIndex,
                promptsandresponses: promptsandresponses,
            };

            newChats.push(newChat);
            let adjustedChats = sortChats(newChats)
            newChats = [...adjustedChats]
        }
            
        let templates = JSON.stringify( newChats)

        console.log("Templates size:", templates.length)
       
        
        try{
           await axios.post(config.url.API_URL + "/deda_ai_api/stories/save", {currentUser, templates},{
                withCredentials:true
            })
        }
        catch (err) {
            setIsLoading(false);
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
            return;
        }
       
        setChatNames(newChats)
        setIsLoading(false);
        
    }

    const onSubmitChat = () => {
        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        SendRequest(chatPrompt)
        
    }

    const onResubmitChat = (prompt) => {
    
        SendRequest(prompt.prompt)
        
    }

    const onSubmitQuestion = (question) => {
       
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        SendRequest(question)

    }

    const onClickRelated = () => {
        setDisplayRelated(!displayrelated)
    }

    const onSummary = () => {
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }
 
        SendSummaryRequest()

    }

 
    async function SendSummaryRequest() {
        if (promptsandresponses.length === 0)
        {
            setStatus(changeLanguage('status', 'exampleText11'))
            return;
        }

        let request = changeLanguage('assistant', 'summarizetext');
       

        let rqst = ''
        promptsandresponses.forEach((item) => {
            rqst += item.response;
        })

        if (rqst.charAt[0] !== '"')
            rqst = '"' + rqst
        if (rqst.charAt[rqst.length-1] !== '"')
            rqst = rqst + '"'

        request = request + rqst;
   
        //Set prompt for display
        let i = 0;
        if (promptsandresponses.length)
        {
            i = promptsandresponses[promptsandresponses.length-1].id + 1
        }

        let r = {
            id:i,
            prompt:changeLanguage('assistant', 'summary'),
            response:"",
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
       
        setPromptsAndResponses([...promptsandresponses, r]) 
        ScrollResponse()
       
       
        if (promptsandresponses.length > 0)
        {
            setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
            handleFocus()
        }
      

        if (confirmDelete.length <= promptsandresponses.length)
        {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a ]) 
        }

        let req = {
            user: currentUser,
            request: request,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setIsLoading(true);
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                    withCredentials:true
                })

            let server_response = JSON.parse(res.data);

             if (promptsandresponses.length)
            {
                i = promptsandresponses[promptsandresponses.length-1].id + 1
            } else 
            {
                i = 0
            }

            topicSummary = server_response.data
            topicSummaryIndex = i
            
            r = {
                id: i,
                prompt:changeLanguage('assistant', 'summary'),
                response: server_response.data,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            };
            
            setWaitOnResponse('')
            handleFocus()

            setPromptsAndResponses([...promptsandresponses, r])
            updateCredits(server_response.tokens)

    
        } catch(err)
        {
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
        }
        setIsLoading(false)
    }

    async function SendRequest(request) {
        
        setStatus("");
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        if (request.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

        let i = 0;
        if (promptsandresponses.length)
        {
            i = promptsandresponses[promptsandresponses.length-1].id + 1
        }

      
        let r = {
            id:i,
            prompt:request,
            response:"",
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
       
        setPromptsAndResponses([...promptsandresponses, r]) 
        ScrollResponse()
       
       
        if (promptsandresponses.length > 0)
        {
            setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
            handleFocus()
        }
      

        if (confirmDelete.length <= promptsandresponses.length)
        {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a ]) 
        }

        setIsLoading(true)

        
        let rqst='';
    
        
        if (topicSummary.length > 0)
        {
            topic = topicSummary
            const temparray = promptsandresponses.filter((value, index) => index > topicSummaryIndex);
            temparray.forEach((item) => {
                topic += item.response
            }) 
        }
        else {
            promptsandresponses.forEach((item) => {
                topic += item.response
            }) 
        }

        console.log("Topic length:", topic.length)
         
        if (topic.length > 3000)
        {
            console.log("Summarize the text - length:", topic.length)

            topicSummary = await getTextSummary(topic)
            topicSummaryIndex = promptsandresponses.length
            console.log("topicSummary:", topicSummary)

            topic = topicSummary
        }

        if (topic.length > 0)
        {
           rqst += `The context of conversation is: ${topic}.\n`
        }


        rqst += "Please, provide an answer to the following prompt:" + request;

        setRequest(request);
        setChatPrompt('')
        
        let req = {
            user: currentUser,
            request: rqst,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

       console.log("Request:", request)
            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                        withCredentials:true
                    })

                let server_response = JSON.parse(res.data);
             
                if (promptsandresponses.length)
                {
                    i = promptsandresponses[promptsandresponses.length-1].id + 1
                } else 
                {
                    i = 0
                }
            
                r = {
                    id: i,
                    prompt: request,
                    response: server_response.data,
                    aiprovider: getAIProvider(),
                    aimodel: getAIModel(),
                    ainame: getAIName(),
                };

                //console.log("Response:", server_response.data)

                setPromptsAndResponses([...promptsandresponses, r])
               
                setWaitOnResponse('')
                handleFocus()
                
                updateCredits(server_response.tokens)
               
            } catch(err)
            {
                console.log("Error:", err)
                setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
                setStatus(`Error: ${checkServerCode(err.response.data)}`)
            
            }

        setIsLoading(false)
    }

    return <AssistantContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse, 
        promptsandresponses, 
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onSubmitChat,
        onClearChat,
        onSummary,
        onSave,
        deleteChat,
        displayChat,
        onDeletePrompt, 
        changeConfirmDelete,
        confirmDelete,
        displaySample,
        isPromptandResponses,
        status,
        setStatus,
       
        onSubmitQuestion,
        onClickRelated,
        displayrelated,
        topic,
        request,
    

        onResubmitChat,
       
    }}>
        {props.children}
    </AssistantContext.Provider>
})

